import { useState, useCallback } from 'react';
import { postParentWindowMessage } from '../utils/post-message';
export var useArtifactsInterval = function () {
    var _a = useState(null), artifactsIntervalId = _a[0], setArtifactsIntervalId = _a[1];
    var clearArtifactsInterval = useCallback(function () {
        if (artifactsIntervalId !== null) {
            clearInterval(artifactsIntervalId);
            setArtifactsIntervalId(null);
        }
    }, [artifactsIntervalId]);
    var startArtifactsInterval = useCallback(function () {
        if (artifactsIntervalId === null) {
            var intervalId = setInterval(function () {
                postParentWindowMessage({
                    type: 'PINWHEEL_INTERNAL_COMM_UP',
                    eventName: 'analytics_request',
                });
            }, 5000);
            setArtifactsIntervalId(intervalId);
        }
    }, [artifactsIntervalId]);
    return {
        startArtifactsInterval: startArtifactsInterval,
        clearArtifactsInterval: clearArtifactsInterval,
    };
};
